module.exports = __webpack_public_path__ + "img/111.10.35954530.png";